<template>
  <div v-if="data.faunas && Object.keys(data.faunas).length > 0">
    <h5 v-if="title">
      {{ title }}
    </h5>
    <div class="table-wrap">
      <table class="table-full">
        <thead>
        <tr>
          <td>{{ $t('Вид животного') }}</td>
          <td class="text-center" v-for="(year, i) in years" :key="i">{{ year.year }}</td>
          <td class="text-center">{{ $t('График') }}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in data.faunas" :key="index">
          <td>
            <router-link :to="{ name: 'animal-view', params: { id: item.faunaId }}">{{ item.faunaName }}</router-link>
          </td>
          <td v-for="(year, i) in years" :key="i">
            {{ (Object.keys(item.years).length > 0 && item.years[year.id]) ? item.years[year.id].value : '' }}
          </td>
          <td class="text-center">
            <div class="view-more-dialog">
              <a href="#" class="btn-add" @click.prevent="openGraphic(item.faunaId)">
                <img
                  src="@/assets/img/icons/graphic-icon.png"
                  alt="statistics"
                  class="analytics-icon"
                >
              </a>
              <div v-if="graphicDialog[item.faunaId]" class="view-more-dialog-body" v-click-outside="hideDialogOutside">
                <apexcharts type="bar" :options="columnOptions[item.faunaId]"
                            :series="columnData[item.faunaId]"></apexcharts>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import vClickOutside from 'v-click-outside'
import Api from '@/model/api'
import { mapMutations } from 'vuex'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    years: Array,
    title: String
  },
  data: () => ({
    columnData: [],
    columnOptions: [],
    graphicDialog: [],
    data: []
  }),
  methods: {
    ...mapMutations(['setLoading']),
    fetchData (search) {
      this.setLoading(true)
      Api.getAnimalAccountingFaunasYearData(search).then((response) => {
        this.data = response.data.reportData
        this.updateChartData()
      })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
        })
      this.setLoading(false)
    },
    updateChartData () {
      Object.entries(this.data.faunas).forEach(([key, value]) => {
        const resName = []
        const resCount = []
        Object.entries(value.years).forEach(([index, element]) => {
          resName.push(element.yearName)
          resCount.push(element.value)
        })
        this.columnData[value.faunaId] = [{
          data: resCount
        }]
        this.columnOptions[value.faunaId] = {
          plotOptions: {
            chart: {
              type: 'bar'
            },
            bar: {
              barHeight: '100%',
              distributed: true,
              dataLabels: {
                position: 'bottom'
              }
            }
          },
          fill: {
            colors: ['#71c4a7']
          },
          legend: {
            show: false
          },
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#fff']
            },
            offsetX: 0,
            dropShadow: {
              enabled: true
            }
          },
          labels: resName,
          yaxis: {
            labels: {
              show: true
            }
          },
          tooltip: {
            theme: 'light',
            x: {
              show: true
            },
            y: {
              title: {
                formatter: function () {
                  return ''
                }
              }
            }
          }
        }
      })
    },
    // просмотр графика
    openGraphic (id) {
      this.graphicDialog = this.graphicDialog.map(function (element, index) {
        return index !== id ? false : element
      })
      this.$set(this.graphicDialog, id, !this.graphicDialog[id])
    },
    hideDialogOutside () {
      this.graphicDialog = this.graphicDialog.map(function (element, index) {
        return false
      })
    }
  }
}
</script>
